import {
  LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST,
  LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS,
  LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL,
  IMAGE_NOTIFICATION_DETAIL_REQUEST,
  IMAGE_NOTIFICATION_DETAIL_SUCCESS,
  IMAGE_NOTIFICATION_DETAIL_FAIL,
  ADD_IMAGE_NOTIFICATION_REQUEST,
  ADD_IMAGE_NOTIFICATION_SUCCESS,
  ADD_IMAGE_NOTIFICATION_RESET,
  ADD_IMAGE_NOTIFICATION_FAIL,
  UPDATE_IMAGE_NOTIFICATION_REQUEST,
  UPDATE_IMAGE_NOTIFICATION_SUCCESS,
  UPDATE_IMAGE_NOTIFICATION_RESET,
  UPDATE_IMAGE_NOTIFICATION_FAIL,
  DELETE_IMAGE_NOTIFICATION_REQUEST,
  DELETE_IMAGE_NOTIFICATION_SUCCESS,
  DELETE_IMAGE_NOTIFICATION_FAIL,
  CLEAR_ERRORS,
} from "../constants/adminImageNotificationConstants";

export const imageNotificationListReducer = (
  state = { notifications: [] },
  action
) => {
  switch (action.type) {
    case LOAD_ALL_IMAGE_NOTIFICATIONS_REQUEST:
      return {
        loading: true,
        notifications: [],
      };

    case LOAD_ALL_IMAGE_NOTIFICATIONS_SUCCESS:
      return {
        loading: false,
        notifications: action.payload.data,
      };

    case LOAD_ALL_IMAGE_NOTIFICATIONS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case UPDATE_IMAGE_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case UPDATE_IMAGE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: action.payload,
      };

    case UPDATE_IMAGE_NOTIFICATION_RESET:
      return {
        ...state,
        isUpdated: false,
        errors: null,
      };

    case UPDATE_IMAGE_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        errors: action.errors,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const imageNotificationDetailReducer = (
  state = { notification: {} },
  action
) => {
  switch (action.type) {
    case IMAGE_NOTIFICATION_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case IMAGE_NOTIFICATION_DETAIL_SUCCESS:
      return {
        loading: false,
        notification: action.payload,
      };

    case IMAGE_NOTIFICATION_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_IMAGE_NOTIFICATION_REQUEST:
      return {
        loading: true,
        isAdded: false,
        errors: null,
      };

    case ADD_IMAGE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        isAdded: true,
        notification: action.payload,
        errors: null,
      };

    case ADD_IMAGE_NOTIFICATION_RESET:
      return {
        ...state,
        isAdded: false,
        errors: null,
      };

    case ADD_IMAGE_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        isAdded: false,
        notification: null,
        error: action.payload,
        errors: action.errors,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const deleteImageNotificationReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_IMAGE_NOTIFICATION_REQUEST:
      return {
        loading: true,
      };

    case DELETE_IMAGE_NOTIFICATION_SUCCESS:
      return {
        loading: false,
        isDeleted: true,
      };

    case DELETE_IMAGE_NOTIFICATION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
